// extracted by mini-css-extract-plugin
export default {"root":"pagination_root__BpCLp"};